(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec63f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec63f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7h67L", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $54bedf16310b445e$export$6503ec6e8aabbaf; }, function (v) { return $54bedf16310b445e$export$6503ec6e8aabbaf = v; });
var $54bedf16310b445e$export$6503ec6e8aabbaf;
var $54bedf16310b445e$export$f7ad0328861e2f03;
"use strict";
var $54bedf16310b445e$var$mapping = new Map();
function $54bedf16310b445e$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$54bedf16310b445e$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $54bedf16310b445e$var$resolve(id) {
    var resolved = $54bedf16310b445e$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$54bedf16310b445e$export$6503ec6e8aabbaf = $54bedf16310b445e$var$register;
$54bedf16310b445e$export$f7ad0328861e2f03 = $54bedf16310b445e$var$resolve;

});

parcelRegister("dEx3m", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $9f08a67144544ac3$export$bdfd709ae4826697; }, function (v) { return $9f08a67144544ac3$export$bdfd709ae4826697 = v; });
var $9f08a67144544ac3$export$bdfd709ae4826697;
var $9f08a67144544ac3$export$c9e73fbda7da57b6;
var $9f08a67144544ac3$export$5a759dc7a1cfb72a;
"use strict";
var $9f08a67144544ac3$var$bundleURL = {};
function $9f08a67144544ac3$var$getBundleURLCached(id) {
    var value = $9f08a67144544ac3$var$bundleURL[id];
    if (!value) {
        value = $9f08a67144544ac3$var$getBundleURL();
        $9f08a67144544ac3$var$bundleURL[id] = value;
    }
    return value;
}
function $9f08a67144544ac3$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $9f08a67144544ac3$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $9f08a67144544ac3$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $9f08a67144544ac3$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$9f08a67144544ac3$export$bdfd709ae4826697 = $9f08a67144544ac3$var$getBundleURLCached;
$9f08a67144544ac3$export$c9e73fbda7da57b6 = $9f08a67144544ac3$var$getBaseURL;
$9f08a67144544ac3$export$5a759dc7a1cfb72a = $9f08a67144544ac3$var$getOrigin;

});

var $45bfbf3dc4edfd28$exports = {};


(parcelRequire("7h67L")).register((parcelRequire("dEx3m")).getBundleURL("3lIFQ"), JSON.parse('["3lIFQ","main.min.fbf40761.js","4LMmL","../img/sprite.385b51e3.svg"]'));

const $db507d52e5851ad8$export$7d9f9b4046392aed = function() {
    return window.navigator.userAgentData?.mobile || window.matchMedia("(max-width: 768px)").matches;
};


// --------- NAVIGATION
// Elements
const $53d7a21526e67041$var$nav = document.querySelector('[data-js="nav"]');
const $53d7a21526e67041$var$mobileBtn = document.querySelector('[data-js="nav-mobile-btn"]');
const $53d7a21526e67041$var$navlist = document.querySelector('[data-js="nav-list"]');
const $53d7a21526e67041$var$navLinks = document.querySelectorAll('[data-js="nav-link"]');
// Elements outside of nav
const $53d7a21526e67041$var$header = document.querySelector('[data-js="header"]');
const $53d7a21526e67041$var$sections = document.querySelectorAll('[data-spy="section"]');
// -------------------------------------------------------------------
const $53d7a21526e67041$var$toggleMobileNav = function() {
    $53d7a21526e67041$var$mobileBtn.classList.toggle("is-active");
    $53d7a21526e67041$var$navlist.classList.toggle("active");
};
const $53d7a21526e67041$var$clickLinkHandle = function(e) {
    const isLink = e.target.hasAttribute("href");
    if (!isLink) return;
    $53d7a21526e67041$var$toggleMobileNav();
    $53d7a21526e67041$var$navlist.removeEventListener("click", $53d7a21526e67041$var$clickLinkHandle);
};
const $53d7a21526e67041$export$abbbf9220a944d5 = function() {
    $53d7a21526e67041$var$mobileBtn.addEventListener("click", (e)=>{
        $53d7a21526e67041$var$toggleMobileNav();
        $53d7a21526e67041$var$navlist.addEventListener("click", $53d7a21526e67041$var$clickLinkHandle);
        // A11Y
        const isExpanded = $53d7a21526e67041$var$mobileBtn.getAttribute("aria-expanded") === "false" ? "true" : "false";
        $53d7a21526e67041$var$mobileBtn.setAttribute("aria-expanded", isExpanded);
    });
};
const $53d7a21526e67041$export$1f3d3a9da2a0fa96 = function() {
    if ((0, $db507d52e5851ad8$export$7d9f9b4046392aed)()) return;
    const handleActiveSection = function(entries) {
        entries.forEach((entry)=>{
            const { isIntersecting: isIntersecting, target: target } = entry;
            const activeNav = document.querySelector(`a[href='#${target.id}']`);
            if (isIntersecting) {
                $53d7a21526e67041$var$navLinks.forEach((link)=>link.classList.remove("active"));
                activeNav.classList.add("active");
            }
            if (!isIntersecting) activeNav.classList.remove("active");
        });
    };
    const options = {
        rootMargin: "0px",
        threshold: [
            0.4,
            0.7,
            0.9
        ]
    };
    const spyObserver = new IntersectionObserver(handleActiveSection, options);
    $53d7a21526e67041$var$sections.forEach((section)=>spyObserver.observe(section));
};
const $53d7a21526e67041$export$6ea2a03303ca6765 = function() {
    if (window.window.innerWidth >= 2400) return;
    const handleBackground = function(entries) {
        const { isIntersecting: isIntersecting } = entries[0];
        if (!isIntersecting) $53d7a21526e67041$var$nav.classList.add("nav--bgc");
        if (isIntersecting) $53d7a21526e67041$var$nav.classList.remove("nav--bgc");
    };
    const options = {
        threshold: 0
    };
    const mainObserver = new IntersectionObserver(handleBackground, options);
    mainObserver.observe($53d7a21526e67041$var$header);
};



// ------------------------------------------------------------
// DOM ELEMENTS
const $c2f1a235f8f5e0c5$var$header = document.querySelector('[data-js="header"]');
const $c2f1a235f8f5e0c5$var$topHeader = document.querySelector('[data-js="header-heading-top"]');
const $c2f1a235f8f5e0c5$var$bottomHeader = document.querySelector('[data-js="header-heading-bottom"]');
const $c2f1a235f8f5e0c5$var$subHeading = document.querySelector('[data-js="header-subheading"]');
const $c2f1a235f8f5e0c5$var$scroll = document.querySelector('[data-js="header-scroll"]');
const $c2f1a235f8f5e0c5$var$photo = document.querySelector('[data-js="header-photo"]');
// ---------------------------------------------------------------
const $c2f1a235f8f5e0c5$var$animationHandle = function() {
    const { bottom: bottom, height: height } = $c2f1a235f8f5e0c5$var$header.getBoundingClientRect();
    const fromTopPosPerc = (1 - bottom / height) * 100;
    const photoOpacity = 10;
    /**
   * Calculate visibility, e.g. For passed parameters: (10, 20) => 50 , (5, 20) => 25
   * @param {number} actualPos - Percentage of actual position from top observed DOM object/container.
   * @param {number} endPointPos - Targeted position in percentage from top observed DOM object/container when returned value will be '100'.
   * @returns {number}
   */ const calcVisibility = function(actualPos, endPointPos) {
        return actualPos / endPointPos * 100;
    };
    const visibility = calcVisibility(fromTopPosPerc, 20);
    const scrollVisibility = 100 - calcVisibility(fromTopPosPerc, 50);
    $c2f1a235f8f5e0c5$var$topHeader.style.transform = `translateY(-${visibility}%)`;
    $c2f1a235f8f5e0c5$var$bottomHeader.style.transform = `translateY(${visibility}%)`;
    $c2f1a235f8f5e0c5$var$subHeading.style.opacity = visibility === 0 ? "1" : "0";
    $c2f1a235f8f5e0c5$var$photo.style.opacity = `${visibility < photoOpacity ? photoOpacity : visibility}%`;
    $c2f1a235f8f5e0c5$var$photo.style.filter = `grayscale(${100 - visibility}%)`;
    $c2f1a235f8f5e0c5$var$scroll.style.opacity = `${scrollVisibility}%`;
    $c2f1a235f8f5e0c5$var$scroll.style.pointerEvents = scrollVisibility <= 0 ? "none" : "all";
};
const $c2f1a235f8f5e0c5$var$observerOptions = {
    rootMargin: "0px",
    threshold: 0.3
};
const $c2f1a235f8f5e0c5$export$5263a95d66ab56f4 = function() {
    if ((0, $db507d52e5851ad8$export$7d9f9b4046392aed)()) return;
    const controlAnimation = function(entries) {
        const { isIntersecting: isIntersecting } = entries[0];
        if (isIntersecting) window.addEventListener("scroll", $c2f1a235f8f5e0c5$var$animationHandle);
        if (!isIntersecting) window.removeEventListener("scroll", $c2f1a235f8f5e0c5$var$animationHandle);
    };
    const observer = new IntersectionObserver(controlAnimation, $c2f1a235f8f5e0c5$var$observerOptions);
    observer.observe($c2f1a235f8f5e0c5$var$header);
};



const $80ffb7da7bdf02eb$var$aboutmeSection = document.querySelector('[data-js="aboutme"]');
const $80ffb7da7bdf02eb$var$mottoEl = document.querySelector('[data-js="my-motto"]');
const $80ffb7da7bdf02eb$var$mottoElQuotes = document.querySelectorAll('[data-js="my-motto__quote"]');
const $80ffb7da7bdf02eb$var$animateTextTyping = function(element, textToType) {
    return new Promise((resolve, reject)=>{
        const textToAnimate = textToType || element.innerText;
        const time = 100;
        let i = 0;
        // Clear before typing animation
        element.innerHTML = "";
        const typeText = function(str) {
            i++;
            $80ffb7da7bdf02eb$var$mottoEl.textContent = str.slice(0, i);
            if (i === str.length) {
                clearInterval(animation);
                resolve();
            }
        };
        const animation = setInterval(()=>{
            typeText(textToAnimate);
        }, time);
    });
};
const $80ffb7da7bdf02eb$export$a586759acdda70cf = function() {
    if ((0, $db507d52e5851ad8$export$7d9f9b4046392aed)()) return;
    const textToType = $80ffb7da7bdf02eb$var$mottoEl.innerText;
    $80ffb7da7bdf02eb$var$mottoElQuotes.forEach((q)=>q.style.opacity = "0");
    $80ffb7da7bdf02eb$var$mottoEl.innerHTML = "";
    const controlAnimation = async function(entries) {
        const { isIntersecting: isIntersecting, target: target } = entries[0];
        if (isIntersecting) {
            observer.unobserve(target);
            $80ffb7da7bdf02eb$var$mottoEl.dataset.typeText = true;
            await $80ffb7da7bdf02eb$var$animateTextTyping($80ffb7da7bdf02eb$var$mottoEl, textToType);
            $80ffb7da7bdf02eb$var$mottoElQuotes.forEach((q)=>q.style.opacity = "1");
            $80ffb7da7bdf02eb$var$mottoEl.dataset.typeText = false;
        }
    };
    const options = {
        rootMargin: "0px",
        threshold: 0.5
    };
    const observer = new IntersectionObserver(controlAnimation, options);
    observer.observe($80ffb7da7bdf02eb$var$aboutmeSection);
};



const $0921925e848ddf01$var$imgs3D = document.querySelectorAll('[data-js="img3D"]');
const $0921925e848ddf01$var$rotate3dElement = function(e, target, maxDegrees, scale) {
    const rotateYposition = (e.layerX / target.scrollWidth * 2 - 1) * maxDegrees;
    const rotateXposition = (e.layerY / target.scrollHeight * 2 - 1) * maxDegrees;
    target.style.transform = `perspective(1200px) rotateX(${rotateXposition}deg) rotateY(${-rotateYposition}deg) scale3d(${scale}, ${scale}, ${scale})`;
};
const $0921925e848ddf01$export$d5c980a96d3b13bc = function() {
    if ((0, $db507d52e5851ad8$export$7d9f9b4046392aed)()) return;
    $0921925e848ddf01$var$imgs3D.forEach((img)=>{
        const screenCentralPoint = window.screen.width / 2;
        const isLeft = img.getBoundingClientRect().right < screenCentralPoint;
        const rotateY = isLeft ? "" : "-";
        img.addEventListener("mousemove", (e)=>{
            img.style.transition = "transform 100ms ease";
            $0921925e848ddf01$var$rotate3dElement(e, img, 10, 1.05);
        });
        img.addEventListener("mouseout", (e)=>{
            img.style.transition = "transform 300ms ease";
            img.style.transform = `perspective(1200px) rotateX(-2deg) rotateY(${rotateY}7deg) scale3d(1.05, 1.05, 1)`;
        });
    });
};


var $cda3974edc793491$exports = {};

$cda3974edc793491$exports = (parcelRequire("dEx3m")).getBundleURL("3lIFQ") + "../img/sprite.385b51e3.svg";


// --------------------------------------------------------------
// DOM Elements
const $8c87c155b38b16eb$var$form = document.querySelector('[data-js="contact-form"]');
const $8c87c155b38b16eb$var$inputs = $8c87c155b38b16eb$var$form.querySelectorAll('[data-js="contact-form__input"]');
const $8c87c155b38b16eb$var$submitBtn = document.querySelector('[data-js="contact-form__submit-btn"]');
// -------------------------------------------------------------
const $8c87c155b38b16eb$var$emailURL = "/"; // "/" - url for netlify forms
const $8c87c155b38b16eb$var$ErrorMsg = {
    fullname: "The Full name should contain at least 3 characters.",
    email: "Please enter a correct email address.",
    message: "The message should contain at least 10 characters."
};
// --------------------------------------------------------------
// disable default html validation
$8c87c155b38b16eb$var$form.setAttribute("novalidate", true);
/**
 * Renders 'error' under the specified DOM Element with specified message.
 * @param {object} element - Input DOM Element
 * @param {string} msg - Text string to be displayed
 */ const $8c87c155b38b16eb$var$renderInputErrorMsg = function(element, msg) {
    const parent = element.closest(".form__row");
    const html = `                
    <p class="error-msg">
    ${msg}
     </p>`;
    parent.insertAdjacentHTML("beforeend", html);
};
/**
 * Remove error message under the specified DOM Element.
 * @param {object} element - Input DOM Element
 */ const $8c87c155b38b16eb$var$removeInputErrorMsg = function(element) {
    const parent = element.closest(".form__row");
    const errorMsg = parent.querySelector(".error-msg");
    if (errorMsg) errorMsg.remove();
};
// Adding or removing loading state from FORM depends on passed parameter
/**
 * Render or remove loading spinner depends on state
 * @param {boolean} addState - true = add loading spinner; false = remove loading spinner
 */ const $8c87c155b38b16eb$var$loadingState = function(addState) {
    $8c87c155b38b16eb$var$form.classList[addState === true ? "add" : "remove"]("loading");
    $8c87c155b38b16eb$var$submitBtn.disabled = addState;
};
/**
 * Render Success message or Error Message for entire form.
 * @param {string} msgType - accepts two strings: 'success' or 'error'
 */ const $8c87c155b38b16eb$var$renderFormMessage = function(msgType) {
    const className = msgType;
    const title = msgType === "success" ? "Thank you" : "Error";
    const msg = msgType === "success" ? "Your message has been delivered." : "Sorry, something went wrong. Please try again later.";
    const icon = msgType === "success" ? "checked" : "error";
    const html = `              
    <div class="message--${className}">
      <p class="title">${title}</p>
      <p class="desc">${msg}</p>
      <svg class="icon">
        <use
          xlink:href="${(0, (/*@__PURE__*/$parcel$interopDefault($cda3974edc793491$exports)))}#icon-mail-${icon}"
        ></use>
      </svg>
    </div>`;
    $8c87c155b38b16eb$var$form.classList.add("form-message");
    $8c87c155b38b16eb$var$form.insertAdjacentHTML("beforeend", html);
};
const $8c87c155b38b16eb$var$checkRequiredFields = function() {
    let isError = false;
    $8c87c155b38b16eb$var$inputs.forEach((el)=>{
        $8c87c155b38b16eb$var$removeInputErrorMsg(el);
        if (!el.checkValidity()) {
            isError = true;
            $8c87c155b38b16eb$var$renderInputErrorMsg(el, $8c87c155b38b16eb$var$ErrorMsg[el.name]);
        }
    });
    return !isError;
};
const $8c87c155b38b16eb$var$makeRequest = async function(data) {
    const res = await fetch($8c87c155b38b16eb$var$emailURL, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams(data).toString()
    });
    if (res.ok) return res;
    throw new Error(`${res.status}: ${res.statusText}`);
};
const $8c87c155b38b16eb$var$submitForm = async function() {
    let isFormValid = $8c87c155b38b16eb$var$checkRequiredFields();
    if (isFormValid) {
        const formData = new FormData($8c87c155b38b16eb$var$form);
        $8c87c155b38b16eb$var$loadingState(true);
        try {
            await $8c87c155b38b16eb$var$makeRequest(formData);
            $8c87c155b38b16eb$var$renderFormMessage("success");
            $8c87c155b38b16eb$var$loadingState(false);
        } catch (error) {
            $8c87c155b38b16eb$var$renderFormMessage("error");
        }
    }
};
const $8c87c155b38b16eb$export$1e436eb08ebd73ca = function() {
    $8c87c155b38b16eb$var$form.addEventListener("submit", (e)=>{
        e.preventDefault();
        $8c87c155b38b16eb$var$submitForm();
    });
};


const $8597dbb500efc06d$var$spanYear = document.querySelector('[data-js="footer-year"]');
const $8597dbb500efc06d$export$b3bed366e0f3268b = function() {
    const actualYear = new Date().getFullYear();
    $8597dbb500efc06d$var$spanYear.innerHTML = actualYear;
};


const $67f0d32f497fe9c7$var$init = function() {
    $53d7a21526e67041$export$abbbf9220a944d5();
    $53d7a21526e67041$export$6ea2a03303ca6765();
    $53d7a21526e67041$export$1f3d3a9da2a0fa96();
    $c2f1a235f8f5e0c5$export$5263a95d66ab56f4();
    $80ffb7da7bdf02eb$export$a586759acdda70cf();
    $0921925e848ddf01$export$d5c980a96d3b13bc();
    $8c87c155b38b16eb$export$1e436eb08ebd73ca();
    $8597dbb500efc06d$export$b3bed366e0f3268b();
};
$67f0d32f497fe9c7$var$init();

})();
//# sourceMappingURL=main.min.fbf40761.js.map
